//* Libraries imports
import { BaseApiService } from "@services/baseApiService";
import { ApiResponse, ApiError } from "@/types/api";
import { api } from "@services/api";

//* Types imports
import type {
  TemplateHistoryPayload,
  ITemplateHistory,
  TemplateHistoryListResponse,
  TemplateHistoryFilters,
} from "./types";

class TemplateHistoryService extends BaseApiService<ITemplateHistory> {
  constructor() {
    super("templates-history");
  }

  async create(
    data: TemplateHistoryPayload
  ): Promise<ApiResponse<ITemplateHistory> | ApiError> {
    if (data.type === "upload" && data.file) {
      const formData = new FormData();
      if (data.templateId) formData.append("templateId", data.templateId);
      if (data.clientId) formData.append("clientId", data.clientId);
      formData.append("type", "upload");
      formData.append("file", data.file);

      return await api.uploadRequest<ITemplateHistory>(
        `/${this.endpoint}`,
        formData
      );
    } else {
      return await super.create(data as any);
    }
  }

  async list(
    filters: TemplateHistoryFilters = {}
  ): Promise<ApiResponse<TemplateHistoryListResponse> | ApiError> {
    console.log(
      "📡 - TemplateHistoryService.ts - Iniciando list com filtros:",
      filters
    );

    // Limpar filtros nulos ou indefinidos
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([_, v]) => v !== null && v !== undefined && v !== ""
      )
    );

    const queryString = new URLSearchParams(cleanFilters as any).toString();
    const url = `${this.baseUrl}${queryString ? `?${queryString}` : ""}`;

    return await api.request<TemplateHistoryListResponse>(url);
  }

  async update(
    id: string,
    data: { mapping?: any; documentUrl?: string }
  ): Promise<ApiResponse<ITemplateHistory> | ApiError> {
    return await super.update(id, data as any);
  }
}

export const templateHistoryService = new TemplateHistoryService();
